import { combineReducers } from 'redux';

import * as types from 'modules/campaignFiles/actionTypes';
import { BULK_CREATION_MODAL_SOURCE } from 'modules/campaigns/constants';
import loading from 'modules/global/reducers/generic.loading';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import bulkFilters from './bulkFilters';

/**
 * @typedef {{
 *  open: boolean,
 *  creating: boolean,
 *  bulkCreating: boolean,
 *  filters: import('./bulkFilters').CampaignFileUIBulkFiltersReducer,
 *  campaignFiles: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 * }} CampaignFileCreationFilesUIReducer
 */

const campaignBulkMatcher = ({ meta }) => meta?.source === BULK_CREATION_MODAL_SOURCE;

export default combineReducers({
  campaignFiles: createSearchReducers(types.FETCH_CAMPAIGN_FILES, {
    global: { matcher: campaignBulkMatcher, paginationSlice: true },
  }),
  open: createReducer(false, {
    [types.OPEN_CREATION_MODAL]: () => true,
    [types.CLOSE_CREATION_MODAL]: () => false,
    [types.CREATE_BULK_FILES_SUCCESS]: () => false,
    [LOCATION_CHANGE]: () => false,
  }),
  filters: bulkFilters,
  creating: loading(types.CREATE_FILE),
  bulkCreating: loading(types.CREATE_BULK_FILES),
});
